export type ApiErrorEnvelope = {
  error?: unknown
  code?: unknown
  message?: unknown
  requestId?: string
  data?: unknown
}

type AppErrorParams = {
  status: number
  code: string
  message: string
  requestId?: string
  data?: unknown
}

export class AppError extends Error {
  readonly status: number
  readonly code: string
  readonly requestId: string | undefined
  readonly data: unknown

  constructor({ status, code, message, requestId, data }: AppErrorParams) {
    super(message)
    this.name = 'AppError'
    this.status = status
    this.code = code
    this.requestId = requestId
    this.data = data
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }
}

function normalizeMessage(message: unknown): string {
  if (typeof message === 'string') return message
  if (message === undefined || message === null) return 'Erro inesperado.'

  try {
    return JSON.stringify(message)
  } catch {
    return 'Erro inesperado.'
  }
}

function normalizeCode(error: unknown, data: unknown): string {
  if (typeof error === 'string' && error.length > 0) return error

  if (data !== null && typeof data === 'object' && 'code' in data) {
    const code = (data as { code?: unknown }).code
    if (typeof code === 'string' && code.length > 0) return code
  }

  return 'UnknownError'
}

export function toAppError(status: number, body: unknown): AppError {
  if (body !== null && typeof body === 'object' && 'message' in body) {
    const envelope = body as Partial<ApiErrorEnvelope>
    const data = envelope.data
    return new AppError({
      status,
      code: normalizeCode(envelope.error ?? envelope.code, data),
      message: normalizeMessage(envelope.message),
      requestId: envelope.requestId,
      data,
    })
  }
  return new AppError({
    status,
    code: 'UnknownError',
    message: 'Erro inesperado ao comunicar com o servidor.',
  })
}
